import { render, staticRenderFns } from "./BaseNotificationBar.vue?vue&type=template&id=9309d184&scoped=true"
import script from "./BaseNotificationBar.vue?vue&type=script&lang=js"
export * from "./BaseNotificationBar.vue?vue&type=script&lang=js"
import style0 from "./BaseNotificationBar.vue?vue&type=style&index=0&id=9309d184&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9309d184",
  null
  
)

export default component.exports